<template>
  <div class="scroll-section">
    <div class="about-bg" :style="'background-image: url('+about_bg+');'"></div>
    <header class="about-header">
      <h1 v-html="$t('about.header_1')" class="animate"></h1>
      <h3 v-html="$t('about.header_2')" class="animate"></h3>
      <h4 v-html="$t('about.header_3')" class="animate"></h4>
    </header>
    <div class="about-content container">
      <div class="columns">
        <article class="column is-one-third animate">
          <h4 class="col-header" v-html="$t('about.header_col_1')"></h4>
          <p v-html="$t('about.content_col_1')"></p>
        </article>
        <article class="column is-one-third animate">
          <h4 class="col-header" v-html="$t('about.header_col_2')"></h4>
          <p v-html="$t('about.content_col_2')"></p>
        </article>
        <article class="column is-one-third animate">
          <h4 class="col-header" v-html="$t('about.header_col_3')"></h4>
          <p v-html="$t('about.content_col_3')"></p>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import aboutBg from '../.././assets/about-bg-optimized.png'
import {mapGetters, mapActions} from 'vuex'

import TweenMax from 'gsap/TweenMax';
import TimelineMax from 'gsap/TimelineMax';
import {isElementVisible} from '../../useElementVisible.js'

export default {
  name: 'About',
  data() {
    return {
      exclude_from_nav: false,
      nav_title: 'about',
      about_bg: aboutBg,
      animationsDone: false,
      animationsInit: false
    }
  },
  mounted() {
    this.hideElements()

    isElementVisible(this.$el, () => {
      this.runSectionAnimations()
    }).attachDefaultEvents()

  },
  watch: {
    active_section_name(val) {
      if (val === this.$options._componentTag) {
        if (!this.is_animating_scroll) {
          this.runSectionAnimations()
        }
      }
    },
    scroll_pos(val) {
      if (this.scroll_pos > (this.$el.offsetTop - 400) && this.scroll_pos < ((this.elHeight - 100) + this.$el.offsetTop)) {
        if (!this.is_animating_scroll) {
          this.runSectionAnimations()
          this.setActiveSection(this.$options._componentTag)
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      active_section_name: 'getActiveSectionName',
      scroll_pos: 'getScrollPos',
      is_animating_scroll: 'getAnimatingScrollState'
    }),
    elHeight() {
      return Math.ceil(this.$el.getBoundingClientRect().height)
    }
  },
  methods: {
    ...mapActions([
      'setActiveSection'
    ]),
    hideElements() {
      if (window.ieLegacy()) {
        return
      }
      let elements = this.$el.querySelectorAll('.animate')
      TweenMax.set(elements, {
        autoAlpha: 0
      })
      let bg = this.$el.querySelector('.about-bg')
      TweenMax.set(bg, {
        autoAlpha: 0
      })
    },
    runSectionAnimations() {
      if (window.ieLegacy()) {
        return
      }
      if (this.animationsDone || this.animationsInit) return
      let els = this.$el.querySelectorAll('.animate')
      let bg = this.$el.querySelector('.about-bg')
      TweenMax.to(bg, 0.8, {
        autoAlpha: 1
      })
      TweenMax.fromTo(bg, 1.2, {
        y: 0
      }, {
        y: -20,
        ease: Power2.easeInOut
      })
      TweenMax.staggerTo(els, 0.7, {
        autoAlpha: 1,
        delay: 0.2
      }, 0.3)
      TweenMax.staggerFromTo(els, 1.7, {
        y: 130
      }, {
        y: 0,
        ease: Power4.easeInOut
      }, 0.2)
      this.animationsInit = true
    }
  }
}
</script>

<style lang="scss" scoped>
.scroll-section {
  position: relative;
  background-color: #2c2d2c;
  padding-top: 282px;
  padding-bottom: 100px;
  @media screen and (max-width: 768px) {
    padding-top: 140px;
  }
  @media screen and (max-width: 768px) {
    padding-bottom: 40px;
  }
}
</style>

<style lang="scss">
$green: #417021;
$red: #ae5a54;
$blue: #6f88aa;
$sand: #c9b06d;
$clay: #866b54;

.green {
  color: $green;
}

.blue {
  color: $blue;
}

.red {
  color: $red;
}

.sand {
  color: $sand;
}

.clay {
  color: $clay;
}

.about-bg {
  position: absolute;
  z-index: 1;
  top: 0;
  width: 1041px;
  padding-bottom: 50%;
  background-size: 100%;
  background-repeat: no-repeat;
  @media screen and (max-width: 1024px) {
    width: 711px;
  }
  @media screen and (max-width: 768px) {
    width: 300px;
  }
}

.about-header {
  position: relative;
  z-index: 2;
  font-size: 5.8rem;
  color: white;
  text-align: center;
  margin-bottom: 2.6rem;

  h3 {
    font-size: 3.2rem;
    text-transform: uppercase;
    width: 75%;
    text-align: center;
    margin: 100px auto 20px auto;
    line-height: 1em;
  }

  h1 {
    line-height: 1;
    text-transform: uppercase;

    + h1 {
      font-weight: 200;
      margin-bottom: 1.6rem;
    }
  }

  h4 {
    color: #ff7c4e;
    font-size: 3.5rem;
    font-family: 'angelique_roseregular';
    width: 50%;
    text-align: center;
    margin: 0 auto;
    line-height: 1.1em;

    strong {
      color: inherit;
      font: inherit;
      font-weight: 700;
    }
  }

  @media screen and (max-width: 768px) {
    font-size: 2.7rem;
    h3 {
      font-size: 2rem;
      margin: 0px auto 20px auto;
    }
    h4 {
      font-size: 1.8rem;
    }
  }

  @media screen and (min-width: 1025px) {
    h3 {
      margin-top: 260px;
    }
  }

}

.about-content {
  position: relative;
  z-index: 3;
  @media screen and (max-width: 1024px) {
    padding: 0 1rem;
  }

  p, p > strong {
    color: white;
  }

  .column {
    @media screen and (max-width: 768px) {
      margin-bottom: 1.5rem;
      text-align: center;
    }
  }

  .column p {
    text-align: left;
  }

}

.column .col-header {
  font-size: 1.8rem;
  color: #fcce03;
  font-weight: 700;
  text-transform: uppercase;
  text-align: left;
  margin-bottom: 1.2rem;
  line-height: 1.2em;
  @media screen and (max-width: 768px) {
    font-size: 1.3rem;
    margin-bottom: .3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sections/About.vue